<template>
	<div class="login">
		<div class="top">
			<img src="../../assets/logo.png" style="width:61px;height:53px" />
			<p>E联智校-云阅卷</p>
		</div>
		<div class="login_content">
			<van-form @submit="onSubmit" style="font-weight: 500;">
				<van-field v-model.trim="userName" name="userName" type="text" label="帐号:" placeholder="请输入用户名" autocomplete/>
				<van-field v-model.trim="passWord" name="passWord" label="密码:" :type="inputType" :right-icon="rightIcon" @click-right-icon="changeType" placeholder="请输入密码" autocomplete/>
				
				<div style="margin: 16px;"><van-button block type="info" color="rgba(0,99,82,1)" v-waves native-type="submit">登录</van-button></div>
			</van-form>
			<a href="https://yue.elianzhixiao.com" class='link-admin'>切换到后台管理</a>
		</div>
		<div class="foot" :style="{ marginTop: marTop }">
			<p>
				Version:{{version}}
				<a href="#" @click="flushVersion" class="editVersion">(版本更新)</a>
			</p>
			<p>{{`© ${new Date().getFullYear()} E联智校 蜀ICP备09016605号-2`}}</p>
		</div>
	</div>
</template>
<script>
import { Toast } from 'vant';
import cookies from "@/utils/cookie";
import { mapActions} from 'vuex'
export default {
    data() {
        return {
        	version:'',
            userName: '',
            passWord: '',
            img: '',
            validCode: '',
            time: '',
            marTop: '',
            inputType: 'password',
            rightIcon: 'closed-eye',
        };
    },
    beforeCreate() {
        // cookies.remove('elink')
    },
    async created() {
        this.del({dbName: 'database', path: 'userInfo',delKey:'token',user: true})
        this.isReload()
        if (window.screen.height > 667) {
            this.marTop = '230px';
        } else {
            this.marTop = '100px';
        }
        let _this = this;
        dd.ready(() => {
            dd.util.domainStorage.getItem({
                name: 'userName',
                onSuccess: function(info) {
                    _this.userName = info.value;
                }
            });
            dd.util.domainStorage.getItem({
                name: 'passWord', // 存储信息的key值
                onSuccess: function(info) {
                    _this.passWord = info.value;
                }
            });
        });
	    this.version = await this.getCurrentVersion()
    },
    methods: {
    	...mapActions('yuejuan/databases',['set','del','get','databaseClear']),
        ...mapActions('yuejuan/version',['operateVersion']),
        isReload(){
    		this.operateVersion({dbName: 'database', path: 'version',user: false,self: this})
	        let baseLocal = Number(localStorage.getItem('reload'))
	        if(baseLocal> 0 && baseLocal< 2 ){
		       setTimeout(_=>{
			       localStorage.setItem('reload', baseLocal+=1)
			       window.location.reload()
		       },300)
	        } else if(baseLocal> 1 && baseLocal< 3){
		        setTimeout(_=>{
                    localStorage.setItem('reload', baseLocal+=1)
                    window.location.reload()
		        }, 500)
	        }
        },
        flushVersion(){
    		this.databaseClear({user: true})
            window.location.reload()
        },
        changeType() {
            if (this.inputType === 'password') {
                this.rightIcon = 'eye-o';
                this.inputType = 'text';
            } else {
                this.inputType = 'password';
                this.rightIcon = 'closed-eye';
            }
        },
        //登录动作
        onSubmit(values) {
            if (!values.userName) {
                Toast('请输入用户名');
                return;
            }
            if (!values.passWord) {
                Toast('请输入密码');
                return;
            }
            this.submitVal(values);
        },
        async submitVal(values) {
            Toast.loading({
                message: '登录中...',
                forbidClick: true,
                duration: 0
            });
            this.getCurrentVersion().then(res=>{
                console.log(res)
            })
            const params = Object.assign({}, values,{v: await this.getCurrentVersion()+'.'+new Date().getTime()})
            this.$post('/phoneLogin', params).then(async data=>{
                if (data.code == '200') {
                    let oldElink = cookies.get('elink')
                    cookies.set('uuid', 'userId-'+data.data.userId)
                    cookies.set('username',this.userName)
                    cookies.set('elink',data.data.elink)
                    let elink = cookies.get('elink')
                    if(elink != undefined  && elink != '' && elink != oldElink ){
                        Toast.loading({
                            message: '正在为您跳转最近的服务节点...',
                            forbidClick: true,
                            duration: 3000
                        });
                        setTimeout(function (){
                            window.location.reload()
                        }, 2000)
                        return;
                    }
                    this.set({dbName: 'database', path: 'userInfo',value:{token: data.data.token,userId:data.data.userId,userName:data.data.userName},user: true})
                    let _this = this;
                    dd.ready(() => {
                        dd.util.domainStorage.setItem({
                            name: 'userName',
                            value: _this.userName
                        });
                        dd.util.domainStorage.setItem({
                            name: 'passWord',
                            value: _this.passWord
                        });
                    });
                    Toast.clear();
                    if(data.data.schoolPersonList.length<=1){
                        cookies.remove('schoolPersonList')
                        this.$router.push({ path: '/home?t='+new Date().getTime() });
                    } else {
                        cookies.set('schoolPersonList',data.data.schoolPersonList)
                        this.$router.push({ path: '/role',query:{userId:data.data.userId}});
                    }
                }
            })
        },
    },
    beforeDestroy() {
    	localStorage.removeItem('reload')
    }
};
</script>
<style lang="less" scoped>
.login {
	position: absolute;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	background: #fff no-repeat;
	background-position: 50% 15%;
	background-size: 61px 53px;
	.reg {
		color: #fff;
		text-align: right;
		font-size: 19px;
		padding: 14px;
	}
	.login_content {
		width: 90%;
		margin-left: 19px;
		margin-top: 110px;
		.van-button {
			background-color: aqua;
			color: #000;
			font-size: 14px;
			font-weight: bolder;
			word-spacing: 10px;
			border: none;
		}
	}
	.van-cell__value {
		.van-field__body {
			.van-field__control {
				font-family: PingFang SC;
				font-weight: 500;
				color: rgba(38, 38, 38, 1);
			}
		}
	}
	input {
		color: rgba(38, 38, 38, 1);
		font-family: PingFang SC;
		font-weight: 500;
	}
	.editVersion{
		font-size: 15px;
		color: rgb(59, 154, 62);
	}
}
.green {
	color: #07664f;
}
.top {
	text-align: center;
	margin-top: 25%;
	> p {
		font-size: 14px;
		margin-top: 20px;
		font-weight: 600;
	}
}
.foot {
	text-align: center;
	width: 100%;
	line-height: 18px;
  font-size: 15px;
}
.link-admin{
	font-size: 14px;
	color: #07664f;
	display: inline-block;
	width: 100%;
	text-align: center;
}
</style>
